import store from '../../redux/store'
import {
    EDIT_PROJECT_GENERALES,
    EDIT_PROJECT_RESET,
    EDIT_PROJECT_HIGH_FREQUENCY,
    EDIT_PROJECT_HEALTH_CHECK
} from '../../redux/redux-const'
import APIInvoke from '../../utils/APIInvoke';
import toast from 'react-hot-toast';
import { setLoading } from '../../template/app-actions';
import { hasText } from '../../utils/StringUtils';


const getState = () => {
    return store.getState().pages.editProject
}

const merge = (type, param) => {
    store.dispatch({
        type,
        payload: {
            ...getState(),
            ...param
        }
    })
}

export const reset = () => {
    store.dispatch({ type: EDIT_PROJECT_RESET })
}

export const init = async (project) => {
    const response = await (await APIInvoke.invokeGET(`/projects/${project}`)).json()
    merge(EDIT_PROJECT_GENERALES, {
        new: false,
        id: response.body.id,
        name: response.body.name,
        tags: response.body.tags || [],
        tokens: response.body.tokens,
        highFrequency: {
            enabled: response.body.highFrequency?.enabled === true,
            maxUpdates: response.body.highFrequency?.maxUpdates || 10,
            timeWindow: response.body.highFrequency?.timeWindow || 1,
            timeWindowUnit: response.body.highFrequency?.timeWindowUnit || "SECONDS",
            cooldown: response.body.highFrequency?.cooldown || 30,
            cooldownUnit: response.body.highFrequency?.cooldownUnit || "MINUTES",
        },
        healthCheck: {
            enabled: response.body.healthCheck?.enabled === true,
            threshold: response.body.healthCheck?.threshold || 0,
            thresholdUnit: response.body.healthCheck?.thresholdUnit || "MINUTES",
        }
    })
}

export const toggleDeleteTokenDialog = (event, row) => {
    const state = getState()
    merge(EDIT_PROJECT_GENERALES, {
        showDeleteDialog: {
            open: !state.showDeleteDialog.open,
            id: row?.id
        }
    })
}

export const updateGenerales = (action) => {
    const name = action.target.name
    const type = action.target.type
    let value = action.target.value


    if (type === "checkbox") {
        value = action.target.checked
    }

    console.log(name, type, value)
    merge(EDIT_PROJECT_GENERALES, { [name]: value })
}


export const addTag = () => {
    const state = getState()

    if (state.tags.some(t => t.name === state.tag)) {
        merge(EDIT_PROJECT_GENERALES, { tag: "", tagColor: "gray" })
        return
    }

    if (!hasText(state.tag) || !hasText(state.tagColor)) {
        toast.error("Tag name and color are required")
        return
    }

    const newTags = {
        name: state.tag,
        color: state.tagColor
    }

    merge(EDIT_PROJECT_GENERALES, { tag: "", tagColor: "gray", tags: [...state.tags, newTags] })
}

export const deleteTag = (tag) => {
    const state = getState()
    // Validar si el tag ya existe en el array

    merge(EDIT_PROJECT_GENERALES, { tags: state.tags.filter(t => t.name !== tag.name) })
}


export const save = async (project, navigate) => {
    const state = getState()
    const request = {
        name: state.name,
        tags: state.tags
    }
    const response = state.id 
            ? await (await APIInvoke.invokePUT(`/projects/${state.name}`, request)).json() 
            : await (await APIInvoke.invokePOST(`/projects`, request)).json()
    if (response.ok) {
        merge(EDIT_PROJECT_GENERALES, {
            new: false,
            id: response.body.id,
            name: response.body.name
        })
        toast.success(response.message)
        window.location = `/projects/${state.name}/edit`
    } else {
        toast.error(response.message)
    }


}

export const onDeleteToken = async (project) => {
    const state = getState()

    const response = await (await APIInvoke.invokeDELETE(`/projects/${project}/tokens/${state.showDeleteDialog.id}`)).json()

    merge(EDIT_PROJECT_GENERALES, {
        showDeleteDialog: {
            open: false
        },
        tokens: state.tokens.filter(t => t.id !== state.showDeleteDialog.id)
    })

    if (response.ok) {
        toast.success(response.message)
    } else {
        toast.error(response.message)
    }
}


export const deleteProject = async (e, navigate) => {
    e.preventDefault()

    const state = getState()

    if (state.deleteProjectName !== state.name) {
        toast.error(`The project name does not match`)
        return
    }

    const response = await (await APIInvoke.invokeDELETE(`/projects/${state.name}`)).json()

    merge(EDIT_PROJECT_GENERALES, {
        showDeleteDialog: {
            open: false
        },
        tokens: state.tokens.filter(t => t.id !== state.showDeleteDialog.id)
    })

    if (response.ok) {
        toast.success(response.message)
        window.location = "/"
    } else {
        toast.error(response.message)
    }
}

export const loadActiveVerificationConfig = async (project) => {
    const response = await (await APIInvoke.invokeGET(`/projects/${project}/verification-configs`)).json()
    merge(EDIT_PROJECT_GENERALES, {
        activeVerificationConfig: response.body
    })
}

export const saveActiveVerificationConfig = async (e, project) => {
    e.preventDefault()
    const state = getState()

    let request = null;

    if (state.activeVerificationConfig.verificationMethod === "ECDSA") {
        request = {
            verificationMethod: state.activeVerificationConfig.verificationMethod,
            keystoreBase64: state.activeVerificationConfig.keystoreBase64,
            keystorePassword: state.activeVerificationConfig.keystorePassword,
            keyAlias: state.activeVerificationConfig.keyAlias
        }
    } else if (state.activeVerificationConfig.verificationMethod === "HMAC") {
        request = {
            verificationMethod: state.activeVerificationConfig.verificationMethod,
            secret: state.activeVerificationConfig.secret,
        }
    } else if (state.activeVerificationConfig.verificationMethod === "SHA256") {
        request = {
            verificationMethod: state.activeVerificationConfig.verificationMethod
        }
    } else if (state.activeVerificationConfig.verificationMethod === "NONE") {
        request = {
            verificationMethod: state.activeVerificationConfig.verificationMethod,
        }
    }

    const response = await (await APIInvoke.invokePOST(`/projects/${project}/verification-configs`, request)).json();

    if (response.ok) {
        toast.success(response.message)
        toggleUpdateVerificationConfigDialog()
    } else {
        toast.error(response.message)
    }
}

export const updateVerificationConfig = (action) => {
    const state = getState()
    const name = action.target.name
    const type = action.target.type
    let value = action.target.value

    if (type === "checkbox") {
        value = action.target.checked
    }

    merge(EDIT_PROJECT_GENERALES, {
        activeVerificationConfig: {
            ...state.activeVerificationConfig,
            [name]: value
        }
    })

}

export const toggleUpdateVerificationConfigDialog = () => {
    const state = getState()
    merge(EDIT_PROJECT_GENERALES, {
        activeVerificationConfig: {
            ...state.activeVerificationConfig,
            showUpdateDialog: !state.activeVerificationConfig.showUpdateDialog
        }
    })
}

export const updateHighFrequency = (action) => {
    const name = action.target.name
    const type = action.target.type
    let value = action.target.value


    if (type === "checkbox") {
        value = action.target.checked
    }

    const state = getState();

    store.dispatch({
        type: EDIT_PROJECT_HIGH_FREQUENCY,
        payload: {
            ...state.highFrequency,
            [name]: value
        }
    })
}

export const updateHealthCheck = (action) => {
    const name = action.target.name
    const type = action.target.type
    let value = action.target.value


    if (type === "checkbox") {
        value = action.target.checked
    }

    const state = getState();

    store.dispatch({
        type: EDIT_PROJECT_HEALTH_CHECK,
        payload: {
            ...state.healthCheck,
            [name]: value
        }
    })
}

export const saveHighFrequency = async (e, project) => {
    e.preventDefault()
    const state = getState()

    try {
        setLoading(true)

        const request = {
            enabled: state.highFrequency.enabled,
            maxUpdates: state.highFrequency.maxUpdates,
            timeWindow: state.highFrequency.timeWindow,
            timeWindowUnit: state.highFrequency.timeWindowUnit,
            cooldown: state.highFrequency.cooldown,
            cooldownUnit: state.highFrequency.cooldownUnit,
        }
        const response = await (await APIInvoke.invokePUT(`/projects/${project}/high-frequency`, request)).json()

        if (response.ok) {
            toast.success(response.message)
        } else {
            toast.error(response.message)
        }
    } catch (error) {
        toast.error(error.message)
    } finally {
        setLoading(false)
    }

}

export const saveHealthCheck = async (e, project) => {
    e.preventDefault()
    const state = getState()

    try {
        setLoading(true)

        const request = {
            enabled: state.healthCheck.enabled,
            threshold: state.healthCheck.threshold,
            thresholdUnit: state.healthCheck.thresholdUnit,
        }
        const response = await (await APIInvoke.invokePUT(`/projects/${project}/health-check`, request)).json()

        if (response.ok) {
            toast.success(response.message)
        } else {
            toast.error(response.message)
        }
    } catch (error) {
        toast.error(error.message)
    } finally {
        setLoading(false)
    }
}